import { FunctionComponent } from "react";

import { useTranslation } from "react-i18next";

import { Icon } from "@/components/Icon/Icon";
import { Information } from "@/components/Information/Information";
import { classNames } from "@/utils/classNames";

import { SearchEngineMeta } from "./searchProfileEngine";

interface SearchEngineBadgeProps {
	meta: SearchEngineMeta;
}

/** Small pill that shows whether an option searches the Database only or Database + AI. */
export const SearchEngineBadge: FunctionComponent<SearchEngineBadgeProps> = ({ meta }) => {
	const { t } = useTranslation();
	const ts = (key: string) => t(`defineIcps.defineIcp.${key}`);

	return (
		<span
			className={classNames(
				"inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide",
				meta.className
			)}
		>
			<Icon className="w-2.5 h-2.5" icon={meta.icon} />
			{ts(meta.labelKey)}
			<Information information={ts(meta.infoKey)} />
		</span>
	);
};
